module.exports = __webpack_public_path__ + "static/media/GuardiansOfAether-Gallery-15.031aa5a4.jpg";